import { oz } from '../../openapi-zod';

export const MongoObjectIdSchema = oz.object({
  $oid: oz.string(),
});

export type MongoIdObject = oz.infer<typeof MongoObjectIdSchema>;